import React from 'react';
import { get } from 'lodash';

import { Skeleton } from '../../index';

const ParagraphSkeleton = ({ lines, lineVariant, animation, isLoading, width, height }) => {
  const lineWidth = (variant) => ({ sx: '60%', md: '80%', lg: '100%' }[variant]);
  const renderParagraphLines = (lines) => {
    let paragraphLines = [];

    for (let i = 0; i < lines; i++) {
      paragraphLines.push(
        <Skeleton
          isLoading={isLoading}
          animation={animation}
          variant="text"
          width={lineWidth(get(lineVariant, `${i}`)) || width}
          height={height}
        />,
      );
    }
    return paragraphLines;
  };
  return renderParagraphLines(lines);
};

ParagraphSkeleton.defaultProps = {
  width: '300px',
  animation: 'pulse',
  lines: '1',
  lineVariant: ['lg', 'md', 'lg', 'sx'],
};

export default ParagraphSkeleton;
